export default "__VITE_ASSET__f7e5f567__"